import { createContext } from 'react';
import uuid from 'react-uuid';
import { decorate, observable, action, toJS } from 'mobx';

import api from '../api';
import * as fn from '../utilities/_functions';

export class ExamInputCreate {
    id = null;
    data = {
        parentGroupId: null,
        key: null,
        name: null,
        descriptionHtml: null,
        examTemplateId: null,
        label: null,
        type: null,
        metadata: null,
    };
    isReady = false;
    isSaving = false;
    hasUnsavedChanges = false;

    cancelExamInputCreate = null;
    cancelExamInputGet = null;

    initialize = (examTemplateId) => {
        this.clear();
        this.id = uuid();
        this.data.examTemplateId = examTemplateId;
        this.isReady = true;
    }

    setMetadata = (key, value) => {
        let metadata = this.data.metadata;

        if (!metadata) {
            metadata = {};
        }

        if (!metadata.hasOwnProperty(key)) {
            metadata = { ...metadata, ...{ [key]: value } };
        } else {
            metadata[key] = value;
        }

        this.data.metadata = metadata;
    }

    removeMetadata = (key) => {
        let metadata = this.data.metadata;

        if (metadata && metadata.hasOwnProperty(key)) {
            delete metadata[key];
        }
    }

    getMetadata = (key) => {
        if (!this.data.metadata) return undefined;
        return this.data.metadata[key];
    }

    clone = (id) => {
        const tmpExamTemplateId = this.data.examTemplateId;
        const that = this;
        this.clear();
        this.isLoading = true;

        return new Promise((resolve, reject) => {
            api.ExamInputs.get(id, (c) => { that.cancelExamInputGet = c })
                .then(({ data }) => {
                    that.data = data;
                    that.data.id = null;
                    that.data.examTemplateId = tmpExamTemplateId;

                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    that.isLoading = false;
                })
        })
    }

    save = (notify) => {
        const that = this;

        if (!!notify) {
            this.isSaving = true;
        }

        return new Promise((resolve, reject) => {
            let option = toJS(that.data);

            if (that.hasUnsavedChanges) {
                api.ExamInputs.create(
                    option,
                    (c) => { that.cancelExamInputCreate = c }
                )
                    .then(({ data }) => {
                        that.id = data.id;
                        that.hasUnsavedChanges = false;
                        option.id = data.id;
                        resolve(option);
                    })
                    .catch(() => {
                        reject();
                    })
                    .finally(() => {
                        that.isSaving = false;
                    })
            } else {
                that.hasUnsavedChanges = false;
                that.isSaving = false;
            }
        })
    }

    clear = () => {
        this.id = null;
        this.data.parentGroupId = null;
        this.data.key = null;
        this.data.name = null;
        this.data.descriptionHtml = null;
        this.data.examTemplateId = null;
        this.data.label = null;
        this.data.type = null;
        this.data.metadata = null;
        this.isReady = false;
        this.isSaving = false;
        this.hasUnsavedChanges = false;

        if (fn.isFunction(this.cancelExamInputCreate)) {
            this.cancelExamInputCreate();
            this.cancelExamInputCreate = null;
        }

        if (fn.isFunction(this.cancelExamInputGet)) {
            this.cancelExamInputGet();
            this.cancelExamInputGet = null;
        }
    }
}

decorate(ExamInputCreate, {
    id: observable,
    data: observable.deep,
    isReady: observable,
    isSaving: observable,
    initialize: action,
    setMetadata: action,
    removeMetadata: action,
    getMetadata: action,
    hasUnsavedChanges: observable,
    save: action,
    clone: action,
    clear: action,
})

export default createContext(new ExamInputCreate());